import styled from "styled-components";

export const LabourCogsWrapper = styled.div`
  .percentage-wrapper {
    font-weight: 325;
    font-family: Ringside Regular-Book;
  }
`;

export const AmountWrapper = styled.div`
  word-wrap: break-word;
  min-width: 68px;
`;

export const PercentageWrapper = styled.div`
  display: flex;
  justify-content: center;
  word-wrap: break-word;
  min-width: 68px;
`;

export const DividerWrapper = styled.div`
  margin: 0px 4px;
`;

export const ChildCardWrapper = styled.div``;
